import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-welcome',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
	checkActive: any;
	@Output() termsAccepted = new EventEmitter();
	@Input('activateCheck')
	set activateCheck(activateCheck: any) {
		this.checkActive = activateCheck;
	}

	constructor() {
		//no content
	}

	ngOnInit(): void {
		//no content
	}

	public changeTerms(event) {
		if (event.target.checked) {
			this.termsAccepted.emit(true);
		} else {
			this.termsAccepted.emit(false);
		}
	}
}
